
import React from 'react';

interface UserStatusProps {
  email: string;
}

const UserStatus: React.FC<UserStatusProps> = ({ email }) => {
  return (
    <div className="text-center p-4 bg-morgenBlue bg-opacity-10 rounded-lg mb-4">
      <p className="text-morgenBlue font-medium">
        Results saved for {email}
      </p>
    </div>
  );
};

export default UserStatus;
